import styled from 'styled-components'

export const YearToggleContainer = styled.div`
  margin-top: 20px;
`

export const YearText = styled.div`
  margin-right: 10px;
`